import { AppConfig } from "../../config";
import { AppConstant } from "../reducer";
import { versionSort, formatBytes, getVersion } from "../../lib/function";


AWS.config.update({ region: 'ap-northeast-2', accessKeyId: AppConfig.DYNAMO_DB_ACCESS_KEY, secretAccessKey: AppConfig.DYNAMO_DB_SECRET_KEY });

const GetAppInfo = (appCode, lang) => async (dispatch) => {
    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        KeyConditionExpression: '#name=:name',
        ExpressionAttributeNames: { '#name': 'name' },
        ExpressionAttributeValues: { ':name': appCode }
    };

    const data = await dc.query(params).promise();

    const templateVersion = data.Items.find(x => x.type.indexOf('t:header') > -1 && x.isVisible).version;
    const feature = data.Items.filter(x => x.type.indexOf('t:body:' + templateVersion + ':feature') > -1 && x.type.substr(-2) == lang);
    const lastestVersion = versionSort(data.Items.filter(x => x.type.indexOf('v:production') == 0 && x.is_active && x.version !== undefined))[0];
    const version = lastestVersion.version;
    const fileSize = formatBytes(lastestVersion.file_size);
    const basicInfo = data.Items.find(x => x.type === 'app');
    const headerInfo = data.Items.find(x => x.type === 't:header:' + templateVersion);
    const movie = data.Items.find(x => x.type === 't:body:' + templateVersion + ':movie:' + lang.toLowerCase())?.movies;
    const intro = data.Items.find(x => x.type === 't:body:' + templateVersion + ':intro:' + lang.toLowerCase())?.introduction;
    const faq = data.Items.find(x => x.type === 't:body:' + templateVersion + ':faq:header')?.faqs
        .sort((a, b) => { return a.order - b.order })
        .map(x => {
            const filtered = data.Items.find(y => y.type === 't:body:' + templateVersion + ':faq:' + x.code + ':' + lang.toLowerCase());
            return { q: filtered?.question, a: filtered?.answer }
        })
    const imageInfo = data.Items.find(x => x.type === 't:body:' + templateVersion + ':image:' + lang.toLowerCase());

    const result = {
        appCode,
        appTitle: basicInfo.title,
        appIcon: headerInfo.icon.direct_link,
        category: basicInfo.category,
        updated: basicInfo.updated,
        description: headerInfo.desc,
        bgImage: headerInfo.bgImage.direct_link,
        provider: headerInfo.provider,
        providerLink: headerInfo.providerLink,
        privacyLink: headerInfo.privacyLink,
        languages: headerInfo.langs,
        tags: headerInfo.tags,
        appAuth: headerInfo.authList,
        screenshot: imageInfo?.images.map((x, idx) => {
            return {
                seq: idx,
                url: x.direct_link,
                is_main: imageInfo.mainImage.direct_link === x.direct_link ? true : false
            }
        }),
        intro,
        faq,
        movie,
        version,
        fileSize,
        feature: feature.map(x => {
            return {
                title: x.title,
                contents: x.content,
                mediaType: x.mediaType,
                mediaLink: (x.mediaType === 'image' && x.image.direct_link) || (x.mediaType === 'movie' && x.movie)
            }
        }),       
        appDownloadInfo: !basicInfo.rayteams_apps ? { type: 'install', version: lastestVersion.version, url: lastestVersion.direct_link, fileSize: lastestVersion.file_size, updated: lastestVersion.updated } : {},
        manualDownloadInfo: basicInfo.manuals?.map(x => {
            return {
                seq: x.sequence,
                title: x.label,
                url: x.file.direct_link,
                fileSize: x.file.file_size,
                visible: x.visible
            }
        })
    };

    dispatch({ type: AppConstant.GET_APP_INFO, data: result });
}

const GetReleaseNotes = (appCode, lang) => async (dispatch) => {
    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        FilterExpression: '#name=:name and begins_with(#type, :p) and contains(#type, :dlang) and #is_active=:true',
        ExpressionAttributeNames: { '#name': 'name', '#type': 'type', '#is_active': 'is_active' },
        ExpressionAttributeValues: {
            ':name': appCode,
            ':p': 'v:production:',
            ':dlang': 'd_lang',
            ':true': true
        }
    };

    const data = await dc.scan(params).promise();
    const filtered = data.Items.filter(x => x.type.split(':')[x.type.split(':').length - 1] === lang);

    dispatch({
        type: AppConstant.GET_RELEASE_NOTES,
        data: versionSort(filtered.map(x => {
            return {
                appCode,
                version: getVersion(x.type.split(':')[2]),
                lang,
                title: x.title,
                contents: x.desc,
                updated: x.updated
            }
        }))
    })
}

const GetManual = (appCode, lang) => async (dispatch) => {
    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        FilterExpression: '#name=:name and begins_with(#type, :bw) and contains(#type, :m)',
        ExpressionAttributeNames: { '#name': 'name', '#type': 'type' },
        ExpressionAttributeValues: {
            ':name': appCode,
            ':bw': 't:body',
            ':m': ':manual:',
        }
    };

    const data = await dc.scan(params).promise();
    const contents = data.Items.find(x => x.type.indexOf(':header') === -1 && x.type.split(':')[x.type.split(':').length - 1] === lang);

    const result = contents?.features && Object.entries(contents?.features).map(x => {
        return {
            code: x[0],
            title: x[1].title,
            contents: x[1].content
        }
    });

    dispatch({ type: AppConstant.GET_MANUAL, data: result })
}

const GetAppList = (lang) => async (dispatch) => {
    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        FilterExpression: '#type=:type and #is_active=:t and #isdev=:n and #showHome=:t',
        ExpressionAttributeNames: { '#type': 'type', '#is_active': 'is_active', '#isdev': 'isdev', '#showHome': 'showHome' },
        ExpressionAttributeValues: { ':type': 'app', ':t': true, ':n': 'N' }
    };

    

    const data = await dc.scan(params).promise();

    const appIcons = await GetAppIcons(data.Items.map(x => { return { appCode: x.name } }));

    const result = data.Items.map(x => {
        return {
            app_icon: appIcons.find(y => y.appCode === x.name).appIcon,
            category: x.category,
            appCode: x.name,
            appName: x.title,
            desc: x.desc
        }
    })

    dispatch({ type: AppConstant.GET_APP_LIST, data: result });
}

const GetFeaturedApps = (apps) => async (dispatch) => {
    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        FilterExpression: '',
        ExpressionAttributeNames: { '#name': 'name', '#type': 'type', '#isVisible': 'isVisible' },
        ExpressionAttributeValues: { ':type': 't:header', ':true': true }        
    };

    params.FilterExpression = `#name in (${apps.map(x => { return (':' + x.appCode.toLowerCase()) }).join(',')}) and begins_with(#type, :type) and #isVisible=:true`;
    apps.forEach(x => {
        params.ExpressionAttributeValues[':' + x.appCode.toLowerCase()] = x.appCode;
    });

    const appTitles = await GetAppTitles(apps);

    const data = await dc.scan(params).promise();
    const result = data.Items.map(x => {
        return {
            seq: apps.find(y => y.appCode === x.name).seq,
            app_icon: x.icon.direct_link,
            appCode: x.name,
            appName: appTitles.find(y => y.appCode === x.name).appTitle,
        }
    }).sort((a, b) => {
        if (a.seq > b.seq) return 1;
        if (a.seq === b.seq) return 0;
        if (a.seq < b.seq) return -1;
    });

    dispatch({ type: AppConstant.GET_FEATURED_APP_LIST, data: result });
}

const GetAppTitles = async (apps) => {
    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        FilterExpression: '',
        ExpressionAttributeNames: { '#name': 'name', '#type': 'type' },
        ExpressionAttributeValues: { ':type': 'app', }
    };

    params.FilterExpression = `#name in (${apps.map(x => { return (':' + x.appCode.toLowerCase()) }).join(',')}) and #type=:type`;
    apps.forEach(x => {
        params.ExpressionAttributeValues[':' + x.appCode.toLowerCase()] = x.appCode;
    });

    const appTitles = await dc.scan(params).promise();

    return appTitles.Items.map(x => { return { appCode: x.name, appTitle: x.title } });
}

const GetAppIcons = async (apps) => {
    const dc = new AWS.DynamoDB.DocumentClient();
    const params = {
        TableName: 'rayrnd-applications',
        FilterExpression: '',
        ExpressionAttributeNames: { '#name': 'name', '#type': 'type','#isVisible':'isVisible' },
        ExpressionAttributeValues: { ':type': 't:header', ':true': true }
    };

    params.FilterExpression = `#name in (${apps.map(x => { return (':' + x.appCode.toLowerCase()) }).join(',')}) and begins_with(#type, :type) and #isVisible=:true`;
    apps.forEach(x => {
        params.ExpressionAttributeValues[':' + x.appCode.toLowerCase()] = x.appCode;
    });

    const appIcons = await dc.scan(params).promise();
    return appIcons.Items.map(x => { return { appCode: x.name, appIcon: x.icon.direct_link } });
}

export const AppAction = {
    GetAppInfo,
    GetManual,
    GetReleaseNotes,
    GetAppList,
    GetFeaturedApps
}
